import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink } from 'react-router-dom';
import { faAngleDoubleRight, faAngleDoubleLeft, faChevronRight, faChevronLeft, faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import Cookies from 'js-cookie';
import ErrorMessage from '../AppLayouts/ErrorMessage';
import { indigo } from '@material-ui/core/colors';
import API_PATH from "../../constants/config.json";
import { setCookie } from '../../functions/Auth';
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;


//Start Css Code ...
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
  },
  addNewStruct: {
    width: '100%',
    '& .MuiPaper-root': {
      width: '100%',
      height: 'auto',
      boxShadow: 'none',
    },
    '& .MuiTextField-root': {
      width: '90%',
      '@media only screen and (min-width: 3501px)': {
        marginBottom:'15px',
      },
    },
    '& input[type="text"]': {
      padding: '10px',
      '@media only screen and (min-width: 3501px)': {
        fontSize:'24pt',
      },
    },
    '& input[type="email"]': {
      padding: '10px',
      '@media only screen and (min-width: 3501px)': {
        fontSize:'24pt',
      },
    },
    '& select#assigned_teams': {
      width: '90%',      
      padding: '5px',
      fontSize: '15px',
      color: '#333',
      backgroundImage: 'none !important',
      '@media only screen and (max-width: 3500px)': {
        height: '245px',
      },
      '@media only screen and (min-width: 3501px)': {
        height: '350px',
      },
     
    },
    '& select#available_teams': {
      width: '80%',      
      padding: '5px',
      fontSize: '15px',
      color: '#333',
      backgroundImage: 'none !important',
      '@media only screen and (max-width: 3500px)': {
        height: '245px',
      },
      '@media only screen and (min-width: 3501px)': {
        height: '350px',
      },
    },
  },
  firstBox: {

  },
  btbBlock: {
    '@media only screen and (max-width: 3500px)': {
      marginTop: '0px',
    },
    '@media only screen and (min-width: 3501px)': {
      marginTop: '25px',
    },
  },
  signInBtn: {
    border: '1px solid #24618E',
    color: '#fff',
    background: '#24618E!important',       
    '@media only screen and (max-width: 3500px)': {
      width: '150px',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '200px',
      marginLeft: '15px',
    },
  },
  cancelBtn: {
    border: '1px solid #333',
    color: '#333',
    background: '#fff!important',       
    '@media only screen and (max-width: 3500px)': {
      width: '150px',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '200px',
    },
  },
  nextbtn: {
    textAlign: 'center',
    paddingTop: '10px',    
    '@media only screen and (max-width: 3500px)': {
      marginTop: '-15px',
    },
    '@media only screen and (min-width: 3501px)': {
      marginTop: '-15px',       
    },
    '& button': {
      border: '1px solid #24618E',
      borderRadius: '3px',
      padding: '6px',
      cursor: 'pointer',
      background: '#fff',
      '@media only screen and (max-width: 3500px)': {
        width: '40px',
        height: '40px',
        fontSize: '20px',
      },
      '@media only screen and (min-width: 3501px)': {
        width: '60px',
        height: '60px',
        fontSize: '35px', 
        marginLeft: '-80px',       
      },
      '& .doubleImg': {
        width: '65%',        
        '@media only screen and (min-width: 3501px)': {
          marginTop: '7px',  
        },
      },
      '& .singleImg': {
        width: '45%',        
        '@media only screen and (max-width: 3500px)': {
          marginTop: '2px',
        },
        '@media only screen and (min-width: 3501px)': {
          marginTop: '7px',  
        },
      }
    }
  },
  btnIcon: {

  },
  maincontent: {
    width: '100%',
  }
}));
//End Css Code ...

//Start UserDetails component code ...
const UserDetails = (props) => {
  const classes = useStyles();
  const [teamsArray, setTeamsArray] = React.useState([]);
  const [errPopUp, setErrPopUp] = React.useState(false);
  const [errMsg, setErrMsg] = React.useState(null);
  const [errMsgType, setErrMsgType] = React.useState('error');
  const [loader, setLoader] = React.useState(false);

  const [firstName, setFirstName] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [organization, setOrganization] = React.useState('');
  const [assignedTeams, setAssignedTeams] = React.useState([]);
  const [availableTeams, setAvailableTeams] = React.useState([]);

  const [errFirstName, setErrFirstName] = React.useState(null);
  const [errLastName, setErrLastName] = React.useState(null);

  const [initialFirstName, setInitialFirstName] = React.useState('');
  const [initialLastName, setInitialLastName] = React.useState('');
  const [initialOrganization, setInitialOrganization] = React.useState('');
  const [initialAssignedTeams, setInitialAssignedTeams] = React.useState([]);

  useEffect(
    () => {
      getUserDetails();
    }, []
  )

  const ShowErrPopUP = () => {
    setErrPopUp(false)
  };
  // This code for set Add all Team in Assign Team start 
  const addAllTeams = async e => {
    e.preventDefault();
    let teamAddArr = teamsArray;
    let avlTeam = document.getElementById("available_teams");
    let output = document.getElementById("assigned_teams");
    let currentOption;
    let i;
    let option;
    for (i = 0; i < avlTeam.length; i++) {
      currentOption = avlTeam[i];
      option = document.createElement("option");
      option.value = avlTeam[i].value;
      option.text = avlTeam[i].innerHTML;
      output.add(option);
      teamAddArr.push(parseInt(avlTeam[i].value));
    }
    avlTeam.options.length = 0;
    setTeamsArray(teamAddArr);
  }
  // This code for set Add all Team in Assign Team end 

  // This code for set remaove all Team in Assign Team start 
  const removeAllTeams = async e => {
    e.preventDefault();
    let output = document.getElementById("available_teams");
    let avlTeam = document.getElementById("assigned_teams");
    let currentOption;
    let i;
    let option;
    for (i = 0; i < avlTeam.length; i++) {
      currentOption = avlTeam[i];
      option = document.createElement("option");
      option.value = avlTeam[i].value;
      option.text = avlTeam[i].innerHTML;
      output.add(option);
    }
    avlTeam.options.length = 0;
    setTeamsArray([]);
  }
  // This code for set Remove all Team in Assign Team end 

  // This code for set Add one Team in Assign Team start 

  const addOneTeams = async e => {
    e.preventDefault();
    let avlTeam = document.getElementById("available_teams");
    let output = document.getElementById("assigned_teams");
    let currentOption;
    let i;
    let option;
    let teamOneAddArr = teamsArray;
    for (i = 0; i < avlTeam.length; i++) {
      currentOption = avlTeam[i];
      if (currentOption.selected == true) {
        option = document.createElement("option");
        option.value = avlTeam[i].value;
        option.text = avlTeam[i].innerHTML;
        output.add(option);
        teamOneAddArr.push(parseInt(avlTeam[i].value));
      }
    }
    avlTeam.remove(avlTeam.selectedIndex);
    setTeamsArray(teamOneAddArr);
  }
  // This code for set Add one Team in Assign Team end 

  // This code for set Add one Team in Available Team start 
  const removeOneTeams = async e => {
    e.preventDefault();
    let output = document.getElementById("available_teams");
    let avlTeam = document.getElementById("assigned_teams");
    let currentOption;
    let i;
    let option;
    let teamOneRemoveArr = teamsArray;
    for (i = 0; i < avlTeam.length; i++) {
      currentOption = avlTeam[i];
      if (currentOption.selected == true) {
        option = document.createElement("option");
        option.value = avlTeam[i].value;
        option.text = avlTeam[i].innerHTML;
        const index = teamOneRemoveArr.indexOf(parseInt(avlTeam[i].value));
        if (index > -1) {
          teamOneRemoveArr.splice(index, 1);
        }
        output.add(option);
      }
    }
    avlTeam.remove(avlTeam.selectedIndex);
    // setTeamsArray(teamOneRemoveArr); 
  }
  // This code for set Add one Team in Available Team end 

  //This method is use for API call to get user details ... start
  const getUserDetails = () => {
    try {
      axios({
        method: 'post',
        data: {
          "userId": parseInt(sessionStorage.getItem('viewUserId')),
        },
        headers: {
          'payload': Cookies.get('payload'),
          'agencyid': sessionStorage.getItem('agency_id')
        },
        url: API_URL + API_PATH.getUserDetailsAPI,
      })
        .then(async function (response) {
          if (response.status && response.status == '200') {
            let arr = [];
            setFirstName(response.data.data.user_details.first_name);
            setLastName(response.data.data.user_details.last_name);
            setEmail(response.data.data.user_details.email);
            setOrganization(response.data.data.user_details.organization);
            setAssignedTeams(response.data.data.assigned_teams);
            setAvailableTeams(response.data.data.available_teams);
            response.data.data.assigned_teams.map((value, index) => {
              arr.push(value.team.teams_id);

            });
            setTeamsArray(arr);
            setInitialFirstName(response.data.data.user_details.first_name);
            setInitialLastName(response.data.data.user_details.last_name);
            setInitialOrganization(response.data.data.user_details.organization);
            setInitialAssignedTeams(response.data.data.assigned_teams);
          } else {
            setFirstName('');
            setLastName('');
            setEmail('');
            setOrganization('');
            setTeamsArray([]);
          }
        })
        .catch(function (error) {
          if (error.response) {
            setFirstName('');
            setLastName('');
            setEmail('');
            setOrganization('');
            setTeamsArray([]);
          } else {
            setFirstName('');
            setLastName('');
            setEmail('');
            setOrganization('');
            setTeamsArray([]);
          }
        })
    } catch (error) {
      console.error(error);
    }
  }
  //This method is use for API call to get user details ... end

  //This method is use for user details form validation ... Start
  const validateForm = async e => { 
    setErrMsg(null)
    e.preventDefault()
    if (firstName == '' &&
      lastName == '') {
      setErrFirstName(true);
      setErrLastName(true);
      setErrMsg('Firstname and Lastname are required');
      setErrPopUp(true)
    } else if (firstName == '') {
      setErrFirstName(true)
      setErrMsg('Firstname is required');
      setErrPopUp(true)
    } else if (lastName == '') {
      setErrLastName(true)
      setErrMsg('Lastname is required');
      setErrPopUp(true)
    } else {
      assignTeams();
    }
  }
  //This method is use for user details form validation ... End

  const handleChange = name => event => {
    if (name == 'first_name') {
      setFirstName(event.target.value);
    } else if (name == 'last_name') {
      setLastName(event.target.value)
    } else if (name == 'organization') {
      setOrganization(event.target.value);
    }
  }

  const assignTeams = () => { // API call to assign team and update user profile
    let data = { "teamId": teamsArray, "userId": parseInt(sessionStorage.getItem('viewUserId')), 'email': email, 'first_name': firstName, 'last_name': lastName, 'organization': organization }    
    
    try {
      axios({
        method: 'post',
        data: data,
        headers: {
          'payload': Cookies.get('payload'),
          'agencyid': sessionStorage.getItem('agency_id')
        },
        url: API_URL + API_PATH.assignTeamAPI,
      })
        .then(async function (response) {
          if (response.status && response.status == '200') {
            if(Cookies.get('email') === email) {
              setCookie('firstName', firstName);
              setCookie('lastName', lastName);
              setCookie('organization', organization && organization !== '' ? organization : '');
            }
            props.usertabBack();
          } else {
            setErrMsgType('error')
            setErrMsg('Something went wrong.');
            setErrPopUp(true)
          }
        })
        .catch(function (error) {
          if (error.response) {
            setErrMsgType('error')
            setErrMsg(error.response.data.message);
            setErrPopUp(true)
            setLoader(false);
          } else {
            setErrMsgType('error')
            setErrMsg('Something went wrong.');
            setErrPopUp(true)
            setLoader(false);
          }
        })
    } catch (error) {
      console.error(error);
    }
  }
  //This method is use for API call to assign team and update user profile .... end

  const clearUserForm = () => {
    setFirstName(initialFirstName);
    setLastName(initialLastName);
    setAssignedTeams(initialAssignedTeams);
    setOrganization(initialOrganization);
  }

  return (
    <React.Fragment>
      <div className={classes.addNewStruct}>
        <div className={classes.root}>
          <p style={{ marginBottom: '10px', marginTop: '0' }}><NavLink to="#" style={{ color: '#24618E' }} onClick={props.usertabBack}><FontAwesomeIcon icon={faAngleLeft} />&nbsp;Return to User Listing</NavLink></p>
          <h5 style={{ margin: '0', paddingLeft: '12px' }}>User Details</h5>
          <div className='errMsg' style={{ width: '23.4%', marginLeft: '18px' }}>
            {errMsg ? <div className={classes.errMsgPassword}><ErrorMessage message={errMsg} visible={ShowErrPopUP} show={errPopUp} msgType={errMsgType} /> </div> : null}
          </div>
          <Grid container spacing={3} className={classes.maincontent}>
            <Grid item xs={7}>
              <form className={classes.rootForm} noValidate autoComplete="off" onSubmit={e => validateForm(e)}>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <Grid xs={12} item>
                      <Paper className={classes.paper} >
                        <TextField id="first_name" className={classes.formInput} placeholder="First Name *" type="text" variant="outlined" value={firstName} required onChange={handleChange('first_name')} />
                      </Paper>
                    </Grid>
                    <Grid xs={12} item>
                      <Paper className={classes.paper} >
                        <TextField id="last_name" className={classes.formInput} placeholder="Last Name *" type="text" variant="outlined" value={lastName} required onChange={handleChange('last_name')} />
                      </Paper>
                    </Grid>
                    <Grid xs={12} item>
                      <Paper className={classes.paper} >
                        <TextField id="email" className={classes.formInput} placeholder="Email *" type="email" value={email} variant="outlined" required disabled={true}/>
                      </Paper>
                    </Grid>
                    <Grid xs={12} item>
                      <Paper className={classes.paper} >
                        <TextField id="organization" className={classes.formInput} placeholder="Organization *" type="text" value={organization} variant="outlined" required onChange={handleChange('organization')} />
                      </Paper>
                    </Grid>
                  </Grid>
                  <Grid item xs={6}>
                    <Paper className={classes.paper} >
                      <p style={{ margin: '0px', marginTop: '-25px' }}>Assigned Teams</p>
                      <select id="assigned_teams" size="10">
                        {
                          assignedTeams.map((value, index) => {
                            return (
                              <option value={value.team.teams_id}>{value.team.team_name}</option>
                            )
                          })
                        }
                      </select>
                    </Paper>
                  </Grid>
                </Grid>
                <Grid item xs={6}>
                  <Paper className={classes.paper}>
                    <div className={classes.btbBlock}>
                      <Button type="reset" variant="outlined" id="cancel_btn" className={classes.cancelBtn} onClick={() => { clearUserForm() }}>
                        Cancel</Button>&nbsp;&nbsp;
                     <Button type="submit" variant="outlined" id="save_btn" className={classes.signInBtn}>
                        Save</Button>
                    </div>
                  </Paper>
                </Grid>
              </form>
            </Grid>
            <Grid item xs={5}>
              <Grid container spacing={3}>
                <Grid xs={2} item>
                  <Paper className={classes.paper} >
                    <div className={classes.nextbtn}>
                      <p><button title="Add all" type="button" id="full_back" onClick={addAllTeams}><img src={require('../../assets/images/dleftArrow.svg')} className="doubleImg" /></button></p>
                      <p><button title="Add" type="button" id="one_back" onClick={addOneTeams}><img src={require('../../assets/images/sleftArrow.svg')} className="singleImg" /></button></p>
                      <p><button title="Remove" type="button" id="one_next" id="one_back" onClick={removeOneTeams}><img src={require('../../assets/images/srightArrow.svg')} className="singleImg" /></button></p>
                      <p><button title="Remove all" type="button" id="full_next" onClick={removeAllTeams}><img src={require('../../assets/images/drightArrow.svg')} className="doubleImg" /></button></p>
                    </div>
                  </Paper>
                </Grid>
                <Grid xs={9} item>
                  <Paper className={classes.paper} >
                    <p style={{ margin: '0px', marginTop: '-25px' }}>Available Teams</p>
                    <select id="available_teams" size="10">
                      {
                        availableTeams.map((value, index) => {
                          return (
                            <option value={value.teams_id}>{value.team_name}</option>
                          )
                        })
                      }
                      {/* <option value={1}>Admins</option>

                      <option value={2}>Data Approvers</option>
                      <option value={3}>Data Importers</option>
                      <option value={4}>Detailed Station Data View</option> */}
                    </select>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>

      </div>
    </React.Fragment>
  );
}

export default UserDetails;
//End UserDetails component code ...